import {
  Component,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

import { SelectedSubproject, Subproject } from '@shared/models';
import { ScreenSizeService, ToastNotificationService } from '@shared/services';
import { toggleScrollState } from '@shared/utils';

@Component({
  selector: 'app-subproject-picker',
  templateUrl: './subproject-picker.component.html',
  styleUrls: ['./subproject-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubprojectPickerComponent {
  @Input({ required: true }) subprojects: Subproject[];
  @Input({ required: true }) selectedSubproject: SelectedSubproject;
  @Input({ required: true }) isAppOnline: boolean;
  @Input({ required: true }) isHandset: boolean;

  @Output() selected = new EventEmitter<number>();

  @ViewChild(MatMenuTrigger) menuTriggerButton: MatMenuTrigger;

  constructor(
    private toastNotificationService: ToastNotificationService,
    protected screenSizeService: ScreenSizeService
  ) {}

  onSubprojectChange(subproject: Subproject): void {
    this.selected.emit(subproject.id);
  }

  copyToClipboardNotification(): void {
    this.toastNotificationService.info(
      $localize`:@@shared.subprojectPicker.txtCopyToClipboard:Subproject name copied to clipboard`
    );
  }

  trackSubproject(_index: number, subproject: Subproject): any {
    return subproject?.id;
  }

  onMenuTriggered(isHandset: boolean): void {
    setTimeout(() => {
      const curSelectedElement = document.getElementsByClassName(
        'subprojectPicker_item selectedMenuItem'
      )[0] as HTMLElement;

      curSelectedElement?.scrollIntoView({ block: 'start' });
    });

    if (isHandset) {
      toggleScrollState(false);
    }
  }

  onMenuClosed(isHandset: boolean): void {
    if (isHandset) {
      toggleScrollState(true);
    }
  }
}
